import { CopyIcon, IconButton, LinkIcon } from '@blueprinthq/joy'
import { Box, Flex, Heading, Text, useToast } from '@chakra-ui/react'
import { useTelehealthLinks } from '@hooks'
import { useStoreState } from 'easy-peasy'
import React, { useMemo } from 'react'

import { copyToClipboard } from '../../../utilities'

export const TelehealthSettings = () => {
  // @ts-ignore
  const { user } = useStoreState(state => state.auth)
  const toast = useToast()
  const { copyLinkToClipboard, telehealthUrlDisplay } = useTelehealthLinks()

  return (
    <Box>
      <Box mb={'medium'} w={'100%'}>
        <Heading mb="xxsmall">Telehealth</Heading>
        <Text fontWeight="bold" mt="medium" mb="small">
          Your telehealth link:
        </Text>

        <Flex alignItems="center">
          <Flex
            style={{ border: '1px solid #E4E5E6' }}
            borderRadius={'4px'}
            width="100%"
            p="4"
            height="48px"
            alignItems="center"
          >
            <LinkIcon />
            <Text pl="small">{telehealthUrlDisplay}</Text>
          </Flex>
          <IconButton
            background={'white'}
            _hover={{
              bg: '#E4E5E6'
            }}
            size="sm"
            aria-label="copy"
            onClick={copyLinkToClipboard}
            style={{
              borderRadius: '4px',
              height: '48px',
              width: '48px',
              margin: '0 4px',
              border: '1px solid #E4E5E6'
            }}
            variant="outline"
          >
            <CopyIcon size="sm" />
          </IconButton>
        </Flex>
        <Text mt="small">
          Using Telehealth is simple. Just send this url to your client via
          email or text and they can join in on their phone, laptop, or tablet.
        </Text>
      </Box>
    </Box>
  )
}
